import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBatchOverviewService } from "../../../../../utils/services/batchesOverview/batchOverviewService";
import { toast } from "react-toastify";

// courseId,pageLength,pageNo,batchId,studentName
export const fetchBatcherOverviewData = createAsyncThunk(
  "/batch/batchOverview",

  // async ({ courseId, pageLength, pageNo, batchId, studentName }) => {
  async ({ courseId, batchId }) => {
    try {
      const data = await getBatchOverviewService({ courseId, batchId });
      return data;
    } catch (error) {
      throw error;
    }
  }
);
